import { createFileRoute } from '@tanstack/react-router'

import { BeneficiariesPageSkeleton } from '#/modules/health/front-office/beneficiaries-page/beneficiaries-page-skeleton.tsx'
import { BeneficiariesPage } from '#/modules/health/front-office/beneficiaries-page/beneficiaries-page.tsx'
import { frontOfficeQueryOptions } from '#/shared/front-office-query-options.ts'

export const Route = createFileRoute('/(customer)/_shell/health-insurance/beneficiaries')({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(
      context.trpc.muta.getMutaBeneficiariesInfos.queryOptions(undefined, frontOfficeQueryOptions),
    ),
  pendingComponent: BeneficiariesPageSkeleton,
  pendingMs: 150,
  component: BeneficiariesPage,
})
